export default ({...props}) => {
  const {palette} = props.theme
  return `
        color: ${palette.primary.main};
    `
}
